import { CanoeIcon, ColorKeys, css } from 'canoe';
import React from 'react';
import styled from 'styled-components';

interface StyledPaletteItemProps {
  active: boolean;
  disabled?: boolean;
  color: ColorKeys;
}
const StyledPaletteItem = styled.div<StyledPaletteItemProps>`
  ${({ theme, active, disabled, color }) => css`
    height: 4em;
    display: flex;
    cursor: pointer;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transition: all 0.2s linear;

    & + & {
      border-top: 1px solid #505562;
    }

    span {
      color: ${theme.colors[color]};
      margin-top: 5px;
      font-size: 10px;
      font-weight: 500;
      cursor: pointer;
    }

    &:hover {
      background-color: ${theme.colors.OnyxGray};
    }

    ${active &&
    css`
      background-color: ${theme.colors.OnyxGray};
    `}

    ${disabled &&
    css`
      pointer-events: none;
      background-color: ${theme.colors.Transparent};
    `}
  `}
`;

interface Props {
  icon: CanoeIcon;
  onFocus: () => void;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
  label?: string;
  onClick: () => void;
  active?: boolean;
  disabled?: boolean;
}

export const Item = ({ icon: Icon, label, active, disabled, ...otherProps }: Props) => {
  let color = 'GlitterGrayD10';
  if (disabled) {
    color = 'OnyxGrayL10';
  } else if (active) {
    color = 'White';
  }
  return (
    <div css={disabled ? { cursor: 'not-allowed' } : undefined}>
      <StyledPaletteItem
        active={!!active}
        disabled={disabled}
        color={color as ColorKeys}
        {...otherProps}
      >
        <Icon color={color as ColorKeys} />
        {label && <span>{label}</span>}
      </StyledPaletteItem>
    </div>
  );
};
